import type React from 'react';

export interface StarFilledIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const StarFilledIcon: React.FC<StarFilledIconProps> = ({
	width = 27,
	height = 26,
	color = '#FFD700', 
	'aria-label': ariaLabel = 'Star Filled Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 27 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
	>
		<path
			d="M13.6133 0L16.532 8.98278H25.977L18.3358 14.5344L21.2545 23.5172L13.6133 17.9656L5.97207 23.5172L8.89075 14.5344L1.24955 8.98278H10.6946L13.6133 0Z"
			fill={color}
		/>
	</svg>
);

export default StarFilledIcon;

